/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Routes, Route, useLocation } from 'react-router-dom';
// import { StripeProvider } from 'react-stripe-elements';

import HomePage from 'containers/HomePage/Loadable';
import LoginPage from 'containers/LoginPage/Loadable';
import LogoutPage from 'containers/LogoutPage/Loadable';
import ResetPasswordPage from 'containers/ResetPasswordPage/Loadable';
import SignupPage from 'containers/SignupPage/Loadable';
import RegisterPage from 'containers/RegisterPage/Loadable';
import NewCustomer from 'containers/NewCustomerPage/Loadable';
import ContractPage from 'containers/ContractPage/Loadable';
import SettingsPage from 'containers/SettingsPage/Loadable';
import HelpPage from 'containers/HelpPage/Loadable';
import HarvestPage from 'containers/HarvestPage/Loadable';
import NotFoundPage from 'containers/NotFoundPage/Loadable';
import ResetPasswordPageWorkers from 'containers/ResetPasswordPageWorkers/Loadable';

import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import Colors from 'utils/Colors';
import { STRIPE_PUBLISHABLE_KEY } from 'utils/constants';

import WithAuth from 'utils/auth/withAuth';
import RedirectComponent from 'components/RedirectComponent';
import RedirectShortenedComponent from '../../components/RedirectShortenedComponent';

const AppWrapperSidebar = styled.div`
  flex-direction: row;
  background-color: ${Colors.whiteBackground};
  color: ${Colors.black};
  min-height: 100vh;
`;

const AppWrapperNoSidebar = styled.div`
  max-width: calc(768px + 16px * 2);
  margin: 0 auto;
  display: flex;
  min-height: 100%;
  padding: 0 16px;
  flex-direction: column;
  background-color: ${Colors.sidebarBackground};
  color: ${Colors.white};
`;

const useFullHeader = ['/login', '/login/new', '/reset', '/register', '/workers/reset'];

// Main application component with hooks
function App() {
  const location = useLocation();
  const AppWrapper = useFullHeader.includes(location.pathname) ? AppWrapperNoSidebar : AppWrapperSidebar;

  return (
    <React.Fragment>
      <React.Fragment>
        <AppWrapper>
          {useFullHeader.includes(location.pathname) ?
            <Header />
            :
            <Sidebar />
          }
          {/* Helmet temporarily disabled for debugging error #525 */}
          {/* <Helmet
            titleTemplate="%s - Medarbeiderne MinSide"
            defaultTitle="Medarbeiderne MinSide"
          >
          </Helmet> */}
          <Routes>
            <Route path="/" element={<WithAuth component={HomePage} requireAuth={false} />} />
            <Route path="/login" element={<WithAuth component={LoginPage} requireAuth={false} />} />
            <Route path="/login/new" element={<WithAuth component={LoginPage} requireAuth={false} />} />
            <Route path="/reset" element={<WithAuth component={ResetPasswordPage} requireAuth={false} />} />
            <Route path="/payments" element={<WithAuth component={HarvestPage} requireAuth={true} />} />
            <Route path="/contract" element={<WithAuth component={ContractPage} requireAuth={true} />} />
            <Route path="/settings" element={<WithAuth component={SettingsPage} requireAuth={true} />} />
            <Route path="/help" element={<WithAuth component={HelpPage} requireAuth={true} />} />
            <Route path="/signup" element={<WithAuth component={SignupPage} requireAuth={false} />} />
            <Route path="/signup/:step" element={<WithAuth component={SignupPage} requireAuth={false} />} />
            <Route path="/register" element={<WithAuth component={RegisterPage} requireAuth={false} />} />
            <Route path="/newcustomer" element={<WithAuth component={NewCustomer} requireAuth={false} />} />
            <Route path="/logout" element={<WithAuth component={LogoutPage} requireAuth={true} />} />
            <Route path="/workers/reset" element={<WithAuth component={ResetPasswordPageWorkers} requireAuth={false} />} />
            <Route path="/shortened" element={<RedirectComponent />} />
            <Route path="/shortenedurl" element={<RedirectShortenedComponent />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AppWrapper>
      </React.Fragment>
    </React.Fragment>
  );
}

export default App;
